
import Cookies from 'js-cookie';

const setGUIDCookie = (guid) => {
    console.log("setGUIDCookie",guid);
    Cookies.set('GUID', guid);
}

const getGUIDCookie = () =>{
    console.log("Cookies.get('GUID')",Cookies.get('GUID'));
    return Cookies.get('GUID');
}

const deleteGUIDCookie = () => {
    Cookies.remove('GUID');
}

export {setGUIDCookie,getGUIDCookie,deleteGUIDCookie}